import React, { useState } from 'react';
import './Header.css';
import trade  from '../trademark.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} >
          <div className="logo-icon">
            {/* <div className="logo-circle logo-circle-1"></div>
            <div className="logo-circle logo-circle-2"></div> */}
            <img src={trade} alt="Logo" />
          </div>
          <span className="logo-text">CodeGenexis</span>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="navigation desktop-nav">
          <a href="#home" className="nav-link" onClick={closeMenu}>Home</a>
          <a href="#about" className="nav-link" onClick={closeMenu}>About</a>
          <a href="#services" className="nav-link" onClick={closeMenu}>Services</a>
          {/* <a href="#contact" className="nav-link" onClick={closeMenu}>Contact</a> */}
        </nav>

        {/* Mobile Burger Menu */}
        <div className="burger-menu" onClick={toggleMenu}>
          <div className={`burger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`burger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`burger-line ${isMenuOpen ? 'open' : ''}`}></div>
        </div>

        {/* Mobile Navigation */}
        <nav className={`navigation mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <a href="#home" className="nav-link" onClick={closeMenu}>Home</a>
          <a href="#about" className="nav-link" onClick={closeMenu}>About</a>
          <a href="#services" className="nav-link" onClick={closeMenu}>Services</a>
          {/* <a href="#contact" className="nav-link" onClick={closeMenu}>Contact</a> */}
        </nav>
      </div>
    </header>
  );
};

export default Header; 